import "./ExceptionalCoffees.css";

export const ExceptionalCoffees = () => {
  return (
    <div className="landingExceptional">
        <div className="landingExceptionalVideoContainer">
            <div className="landingExceptionalVideoWrapper">
                <iframe title="Fellow Tasting" className="landingExceptionalVideo" src="https://www.youtube.com/embed/WgQTJuz9HY0" style={{width: "100%", height: "100%"}} allowfullscreen="true" >
                </iframe>
            </div>
        </div>
        <div className="landingExceptionalCopyContainer">
            <div className="landingExceptionalTitle">
                Exceptional coffees deserve unique recipes.
            </div>
            <div className="landingExceptionalText">
                We'll show you how to pull out every fascinating nuance from each coffee, with insights from some of the best baristas in the world.
            </div>

        </div>
        <div className="landingExceptionalStickersContainer">
            <div className="landingExceptionalHotlineSticker">
                <img alt="1-800-Hotline-Brew" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Coffee_Stickers/Section_1.svg"} width="100%" height="100%"/>
            </div>
            <div className="landingExceptionalBeanzSticker">
                <img alt="Beanz" src={process.env.REACT_APP_IMAGE_BASE + "/landing/Illustrations/Coffee_Stickers/beanz_3.png"} width="100%" height="100%"/>
            </div>
        </div>

    </div>

  );
}

